module.exports = __webpack_public_path__ + "img/filetype_ppt.c77e2537.png";